import { z } from 'zod';
/** Progress demo-data slice — the Account Progress challenge accounts (AP_ACCOUNTS, design-reference script lines 988–1007).
 *  Every field is deterministic, seeded and labeled simulated; `seed` drives the slice's apTrades() generator bit-for-bit. */
export const ApAccountSchema = z
  .object({
    id: z.string(),
    nickname: z.string(),
    broker: z.string(),
    currency: z.string(),
    startingBalance: z.number(),
    currentBalance: z.number(),
    profitTarget: z.number(),
    dailyDrawdownLimit: z.number(),
    totalDrawdownLimit: z.number(),
    challengeDays: z.number(),
    daysElapsed: z.number(),
    daysRemaining: z.number(),
    challengeStart: z.string(),
    seed: z.number(),
    score: z.number(),
    scoreLabel: z.string(),
    confidence: z.number(),
    summary: z.string(),
    projected: z.string(),
    best: z.string().nullable(),
    worst: z.string().nullable(),
    strengths: z.array(z.string()),
    risks: z.array(z.string()),
  })
  .strict();
export const ProgressDataSchema = z.object({ apAccounts: z.array(ApAccountSchema) }).strict();
export type ProgressData = z.infer<typeof ProgressDataSchema>;
export type ApAccount = z.infer<typeof ApAccountSchema>;
